import { styled } from "@mui/material";

const Styled = {};

Styled.PaddedContainer = styled("div")(() => ({
  width: 1200,
  maxWidth: 1200,
}));

Styled.RootContainer = styled("div")(() => ({
  width: "100%",
  height: "100%",
  marginTop: 104,
  display: "flex",
  justifyContent: "center",
}));

Styled.RootContainerChildWrapper = styled("div")(() => ({
  width: 1200,
  maxWidth: 1200,
}));

export default Styled;
